// Generate code from clean architecture template

import { CourseEntity } from '../entities';
import { CourseRepository } from '../ports/repositories';

export class FindCourseUsecase {
  constructor(private readonly repo: CourseRepository) {}

  async run(id: string): Promise<CourseEntity> {
    const data = await this.repo.getDetailCourse(id);
    return data;
  }
}
